import { render } from "./dia-chi-thuong-tru.vue?vue&type=template&id=45e41d3a"
import script from "./dia-chi-thuong-tru.vue?vue&type=script&lang=js"
export * from "./dia-chi-thuong-tru.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__